import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { tagsApi } from '../api/tags'

const TAGS_KEY = 'tags'

export const useTags = () => {
  return useQuery({
    queryKey: [TAGS_KEY],
    queryFn: tagsApi.getTags,
  })
}

export const useCreateTag = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: tagsApi.createTag,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [TAGS_KEY] })
    },
  })
}

export const useSearchTags = (query: string, limit = 10) => {
  return useQuery({
    queryKey: [TAGS_KEY, 'search', query],
    queryFn: () => tagsApi.searchTags(query, limit),
    enabled: query.length >= 2,
  })
}
